// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__1B4Tw","title":"styles_title__3j9vp","subTitle":"styles_subTitle__3VFJT","cartItems":"styles_cartItems__GvIvZ","textContainer":"styles_textContainer__3cdPa"};